
import React from 'react';
import styles from './_message-viewer.module.scss';
import { AppState } from '../../../Store/rootReducer';
import { Alert } from '../../../Components/Shared/Interfaces/Alert';

import { Alert as MaterialAlert, AlertTitle } from '@mui/material';
import { removeAlert } from '../../../Store/Shared/actions';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../Store/useAppDispatch';
export interface MessageViewerProps {

}

export default function MessageViewer(props: MessageViewerProps) {
  const alerts = useSelector<AppState, Alert[]>(appState => appState.shared.alerts);
  const dispatch = useAppDispatch();  
  return (
    <>
      {alerts.length > 0 && (
        <div className={styles.messageViewerContainer}>
          {alerts.map((a: Alert, key) => {
            return (
              <MaterialAlert key={key} severity="error" variant="outlined"
                onClose={() => dispatch(removeAlert(a.id))}
              >
                <AlertTitle>Error</AlertTitle>
                {a.message}
              </MaterialAlert>
            )
          })}
        </div>
      )}
    </>
  );
}
